import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { JsonResult } from '../core/json-result.model';
import { ComplaintTBL } from '../models/complaint.table.model';
import { Observable } from 'rxjs';
import { Complaint } from '../models/complaint/complaint.model';
import { ComplaintInsertResponse } from '../models/complaint/complaintInsertResponse.model';
import { EnvironmentService } from '../core/services/environment.service';
import { CommonService } from './common.service';
import { takeUntil } from 'rxjs/operators';
import { ClaimsBlocking } from '../models/complaint/ClaimsBlocking.model';
import { ClaimsBlockingResponse } from '../models/complaint/ClaimsBlockingResponse.model';

@Injectable({
  providedIn: 'root'
})
export class ComplaintService {
  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private commonService: CommonService) { }
  /**
   * Lista reclamos
   * @param accountId número de cuenta
   * @param complaintNumber número de reclamo
   * @param email
   */ 
  
  list(accountId: string, complaintNumber: string): Observable<JsonResult<ComplaintTBL[]>> {
    let url = `${this.environmentService.virtualOfficeServiceUrl}Complaint/ListComplaints`;
    //let url = `http://localhost:57954/api/Complaint/ListComplaints`;
    let httpParams = new HttpParams();
    httpParams = httpParams.append("accountId", accountId);
    httpParams = httpParams.append("complaintNumber", complaintNumber);
    return this.httpClient.get<JsonResult<ComplaintTBL[]>>(url, { params: httpParams }).pipe(takeUntil(this.commonService.unauthorizedAnnounced));
  }

  add(complaint: Complaint) {
    
 
    let url = `${this.environmentService.virtualOfficeServiceUrl}Complaint/Add`;
    return this.httpClient.post<JsonResult<ComplaintInsertResponse>>(url, complaint);
  }

  addFileComplaints(complaint: any) {

    let url = `${this.environmentService.virtualOfficeServiceUrl}Complaint/AddFileComplaints`;
    return this.httpClient.post<any>(url, complaint);
  }

  getInfo(claimsBlocking:ClaimsBlocking): Observable<JsonResult<ClaimsBlockingResponse[]>> {
 
  
    let url = `${this.environmentService.virtualOfficeServiceUrl}Complaint/ListBloqueoComplaints`; 
    return this.httpClient.post<JsonResult<ClaimsBlockingResponse[]>>(url, claimsBlocking);
  }

  download(accountId: string, complaintNumber: string, complaintType: string) {
    let url = `${this.environmentService.virtualOfficeServiceUrl}Complaint/DownloadClaimDocument`;
    //let url = `http://localhost:57954/api/Complaint/DownloadClaimDocument`;
    let headers = new HttpHeaders();
    headers = headers.append("Accept", "application/octet-stream");
    let params = new HttpParams();
    params = params.append("accountId", accountId);
    params = params.append("complaintNumber", complaintNumber);
    params = params.append("complaintType", complaintType);
    return this.httpClient.get(url, { headers: headers, params: params, responseType: 'blob' });
  }
}
